import ClientService from '../services/client.services';
import { Client, ClientCredentials, NewClient, NewClientCredentials } from '../types/Client';
import ToastNotification from '../utils/ToastNotification';

const ClientController = class ClientController {
    public async getAllClients(
        offset?: number,
        limit?: number,
        filters?: { [key: string]: any },
    ): Promise<{ count: number; list: Client[] }> {
        return ClientService.getAllClients(offset, limit, filters);
    }

    public async countAllClients(): Promise<number> {
        const data = await ClientService.countAllClients();
        return data.count;
    }

    public async getClientById(clientId: number): Promise<Client> {
        const client: Client = await ClientService.getClientById(clientId);
        return client;
    }

    public async getCredentials(clientId: number): Promise<ClientCredentials> {
        const credentials: ClientCredentials = await ClientService.getClientCredentialsByClientId(clientId);
        return credentials;
    }

    public async createClient(newClientData: NewClient): Promise<Client> {
        const client: Client = await ClientService.createClient(newClientData);
        ToastNotification({
            type: 'success',
            message: 'Success',
            description: `Client ${newClientData.name} has been successfully created`,
        });
        return client;
    }

    public async updateClientById(clientId: number, clientData: NewClient): Promise<Client> {
        const client: Client = await ClientService.updateClientById(clientId, clientData);
        ToastNotification({
            type: 'success',
            message: 'Success',
            description: 'Client has been successfully updated',
        });
        return client;
    }

    public async upsertCredentials(clientId: number, credentials: NewClientCredentials): Promise<boolean> {
        const saved = await ClientService.upsertCredentials(clientId, credentials);
        ToastNotification({
            type: 'success',
            message: 'Success',
            description: 'Client credentials has been successfully updated',
        });
        return saved;
    }

    public async deleteClientById(clientId: number): Promise<void> {
        await ClientService.deleteClientById(clientId);
        ToastNotification({
            type: 'success',
            message: 'Success',
            description: 'Client has been successfully deleted',
        });
    }
};

export default new ClientController();
